var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolBookmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 5.83317H16.6668M3.3335 3.33317V14.9998C3.3335 16.3732 4.90144 17.1572 6.00016 16.3332L9.00017 14.0832C9.59276 13.6387 10.4076 13.6387 11.0002 14.0832L14.0002 16.3332C15.0989 17.1572 16.6668 16.3732 16.6668 14.9998V3.33317C16.6668 2.4127 15.9206 1.6665 15.0002 1.6665H5.00016C4.07969 1.6665 3.3335 2.4127 3.3335 3.33317Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolBookmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_bookmark.892874c6f35513c02afa3b527b432e68.svg";